module.exports = __webpack_public_path__ + "img/epicycloid_info_giparch.60d5a734.jpg";